import React, { useState, useEffect } from 'react';
import { Box, Button, CircularProgress, DialogContent } from '@mui/material';
import {
    DataGridPro,
    GridToolbar
} from '@mui/x-data-grid-pro';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { toast } from 'react-toastify';

var api = axios.create({ withCredentials: true });

const Schedules = (props) => {
    const { getAccessTokenSilently } = useAuth0();
    const [schedules, setSchedules] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUserSchedules = () => {
        const data = { email: props.user.email };

        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(`${process.env.REACT_APP_BASEURL}/api/scheduler/getall`,
                data,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            ).then((response) => {
                const schedules = response.data.map((schedule, index) => {
                    return { ...schedule.data, _id: index };
                });
                setSchedules(schedules);
                setLoading(false);
            }).catch(error => {
                toast.error('Error fetching schedules.');
                setLoading(false);
            });
        });
    };

    const handleRemoveSchedule = (schedule) => {
        const data = {
            schedule: schedule.schedule,
            customers: schedule.customers,
            staff: schedule.staff,
            email: schedule.email,
            view: schedule.view,
            dashboard: schedule.dashboard,
            title: schedule.title,
            type: schedule.type,
            timezone: schedule.timezone
        };

        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(`${process.env.REACT_APP_BASEURL}/api/scheduler/delete`,
                data,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            ).then((response) => {
                toast.success('Schedule removed.');
                fetchUserSchedules();
            }).catch(error => {
                toast.error('Error removing schedule.');
            });
        });
    };

    useEffect(() => {
        fetchUserSchedules();
    }, []);

    const columns = [
        { field: 'title', headerName: 'Title', flex: .25, minWidth: 100, type: 'string' },
        { field: 'view', headerName: 'View', flex: .25, minWidth: 100, type: 'string' },
        { field: 'type', headerName: 'Type', flex: .25, minWidth: 100, type: 'string' },
        { field: 'schedule', headerName: 'Schedule', flex: .25, minWidth: 100, type: 'string' },
        { field: 'timezone', headerName: 'Timezone', flex: .25, minWidth: 100, type: 'string' },
        {
            field: 'delete',
            headerName: 'Remove',
            flex: .25, minWidth: 100, type: 'string',
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleRemoveSchedule(params.row)}
                >
                    Remove
                </Button>
            )
        }
    ];

    return (
        <DialogContent>
            {loading ? (
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 3, alignItems: 'center', textAlign: 'center' }}
                >
                    <CircularProgress size={60} thickness={4} />
                </Box>
            ) : (
                <Box flexGrow={1} sx={{ padding: '20px' }}>
                    <div style={{ height: '80vh', width: '100%' }}>
                        <DataGridPro
                            slots={{
                                toolbar: GridToolbar
                            }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 }
                                }
                            }}
                            rows={schedules}
                            columns={columns}
                            pagination
                            disableRowSelectionOnClick
                            getRowId={(row) => row._id}
                        />
                    </div>
                </Box>
            )}
        </DialogContent>
    );
};

export default Schedules;